import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  MenuItem,
  Stack,
  IconButton,
  useTheme,
} from "@mui/material";
import { useForm, SubmitHandler } from "react-hook-form";
import { FormProvider, RHFTextField } from "@app/components";
import { Icon } from "@iconify/react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@app/redux/root-reducer";
import { addStatus } from "../slice";
import { useLocation, useNavigate } from "react-router-dom";

interface IStatusForm {
  status: string;
}

const statusOptions = [
  { value: "Assigned", label: "Assigned" },
  { value: "Pending", label: "Pending" },
  { value: "Rejected", label: "Rejected" },
];

export const ChangeStatusModal = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();

  const [open, setOpen] = useState(false);
  const [defaultStatus, setDefaultStatus] = useState("Assigned");
  const location = useLocation();
  const { requestId } = location.state as { requestId: number };
  

  const { requestData } = useSelector((state: RootState) => ({
    requestData: state.requestReducer,
  }));

  const methods = useForm<IStatusForm>({
    defaultValues: {
      status: defaultStatus,
    },
  });

  const { handleSubmit, reset } = methods;

  useEffect(() => {
    if (open) {
      reset({ status: defaultStatus });
    }
  }, [open, defaultStatus, reset]);

  const onSubmit: SubmitHandler<IStatusForm> = (data) => {
    if (!requestId) {
      console.error("No request ID found!");
      return;
    }

    dispatch(
      addStatus({
        id: requestId,
        status: data.status,
        type: "status_update"
      })
    );

    setOpen(false);
    navigate(-1);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    navigate(-1);
  };

  // Auto open modal when component mounts
  useEffect(() => {
    if (requestId) {
      handleOpen();
    }
  }, [requestId]);

  return (
    <Dialog 
      open={open} 
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
    >
      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <DialogTitle>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            Change Status
            <IconButton onClick={handleClose} sx={{ p: 0 }}>
              <Icon icon="mdi:close" />
            </IconButton>
          </Stack>
        </DialogTitle>

        <DialogContent>
          <DialogContentText sx={{ mb: 2 }}>
            Choose a new status for request ID
          </DialogContentText>
          <RHFTextField name="status" label="Status" select fullWidth>
            {statusOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </RHFTextField>
        </DialogContent>

        <DialogActions sx={{ p: 3, pt: 1, gap: 1.5 }}>
          <Button variant="outlined" onClick={handleClose} sx={{ flex: 1 }}>
            Cancel
          </Button>
          <Button type="submit" variant="contained" sx={{ flex: 1 }}>
            Change Status
          </Button>
        </DialogActions>
      </FormProvider>
    </Dialog>
  );
};